import React, { Component } from 'react';
import { Redirect } from 'react-router';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import Icon from "../components/Selfcare/Common/Icon";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Slider from "react-slick";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReactLoading from 'react-loading';
import Collapse, { Panel } from 'rc-collapse';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import BorderColorIcon from '@material-ui/icons/BorderColor';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Version from "version";

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';
import ReactGA from 'react-ga';
import viaplayLogo from '../assets/img/viaplay.png';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

class ChangeService extends Component {
    constructor(props) {
        super(props);
        var GroupId = window.sessionStorage.GroupId;
        var ServiceNo = window.sessionStorage.ServiceNo;
        this.vm = dotnetify.react.connect("ChangeService", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg: {
                GroupId,
                ServiceNo,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Packages: null,
            ChangeTVServiceDialogOpen: false,
            OrderSent: false,
            OrderError: '',
            OrderOpen: '',
            ErrorField: '',
            ErrorText: '',
            DisableButtons: false,
            buzy: false,
            Type: 'Loading',
            password: '',
            passCode: '',
            EnterPasswordDialogOpen: false,
            EnterPassCodeDialogOpen: false,
            CancelTVServiceDialogOpen: false,
            anchorEl: null,
            ButtonText: ' ',
            SelectSimType: false,
            SelectedSimType: '',
        };
    }
    componentDidMount() {
        //setTimeout(
        //    function () {
        //        this.dispatchState({ Init: { GroupId: window.sessionStorage.GroupId, ServiceNo: window.sessionStorage.ServiceNo } });
        //    }.bind(this),
        //    100
        //);
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OpenUrl && !this.state.OpenUrl) {
            let a = document.createElement('a');
            a.href = nextState.OpenUrl;
            a.target = "_blank";
            a.click();
        }
        if (nextState.RedirectUrl && !this.state.RedirectUrl) {
            this.setState({ redirect: true, toUrl: nextState.RedirectUrl });
        }
        if (nextState.StateName && !this.state.StateName) {
            setTimeout(
                function () {
                    this.setState({ [nextState.StateName]: nextState.StateValue });
                }.bind(this),
                5
            );
        }
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (nextState.Type !== "Loading" && this.state.Type === "Loading") {
            setTimeout(
                function () {
                    this.setState({ show: true });
                }.bind(this),
                10
            );
        }
        if (nextState.Message && !this.state.Message) {
            MySwal.fire({
                title: nextState.Message.MessageTitle,
                html: nextState.Message.MessageText,
                icon: nextState.Message.MessageType,
                confirmButtonText: nextState.Message.ConfirmButtonText,
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                if (nextState.Message.OpenUrl) {
                    let a = document.createElement('a');
                    a.target = '_blank';
                    a.href = nextState.Message.OpenUrl;
                    a.click();
                }
                if (nextState.Message.RedirectToUrl) {
                    this.setState({ redirect: true, toUrl: nextState.Message.RedirectToUrl });
                }
            });
        }
        if (nextState.OrderOpen && !this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: true });
                }.bind(this),
                100
            );
        }
        if (!nextState.OrderOpen && this.state.OrderOpen) {
            setTimeout(
                function () {
                    this.setState({ DisableButtons: false });
                }.bind(this),
                100
            );
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    handleConfirmChangeTVServiceDialogClose = () => {
        this.dispatchState({
            PerformChangeTVService: { SelectedServiceNo: this.state.SelectedPackage.ServiceNo, SelectedServiceName: this.state.SelectedPackage.Variant }
        });
        this.setState({ ChangeTVServiceDialogOpen: false, buzy: true });
    }
    handleChange = event => {
        this.setState({ value: event.target.value });
        this.setState({ error: null });
    };

    handleChangeTVServiceDialogClose = () => {
        this.setState({ ChangeTVServiceDialogOpen: false, SelectedPackage: null, error: null });
    }

    handleEnterPasswordDialogClose = () => {
        this.dispatchState({ EnterPasswordDialogOpen: false });
    }

    handleInputChange = name => event => {
        this.setState({ [name]: event.target.value, PasswordErrorText: '' });
    };

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    handleSelectPackage = selectedPackage => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Sumo package selected'
        });
        if (!selectedPackage.CanChangeTo) { //Order package
            this.dispatchState({ OrderTVService: selectedPackage.ServiceNo });
            this.setState({ buzy: true });
        }
        else { //Change package
            this.setState({ SelectedPackage: selectedPackage, ChangeTVServiceDialogOpen: true });
        }

    };

    handleClick = (event, popoverId) => {
        this.setState({
            openedPopoverId: popoverId,
            anchorEl: event.currentTarget,
        });
    };
    handleCancelTVServiceDialogClose = () => {
        this.setState({ CancelTVServiceDialogOpen: false, CancelService: null, error: null, value: null });
    };

    //handleConfirmCancelTVServiceDialogClose = () => {
    //    if (!this.state.value) {
    //        this.setState({ error: this.props.t('selfcare:error.mustselecttimeforcancellation') });
    //        return;
    //    }
    //    this.setState({ error: null, CancelTVServiceDialogOpen: false });
    //    console.log(this.state.CancelService);
    //    this.dispatchState({ CancelTVService: { ProductNo: this.state.CancelService.ServiceNo, CancelAtEndOfPeriod: this.state.value === "endofperiod" } });
    //};
    cancelTVService = service => {
        ReactGA.event({
            category: 'Navigation',
            action: 'TVService cancel'
        });

        this.dispatchState({ CancelTVService: { ProductNo: service.ServiceNo, CancelAtEndOfPeriod: true }});
    }

    handleClose = () => {
        this.setState({
            openedPopoverId: null,
            anchorEl: null,
        });
    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        console.debug('ChangeService render');
        var settings = {
            arrows: true,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 99999999,
                    settings: {
                        slidesToShow: 5,
                        infinite: this.state.Options && this.state.Options.length > 5 ? true : false,
                    }
                },
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        infinite: this.state.Options && this.state.Options.length > 4 ? true : false,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        infinite: this.state.Options && this.state.Options.length > 3 ? true : false,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        infinite: this.state.Options && this.state.Options.length > 2 ? true : false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        infinite: this.state.Options && this.state.Options.length > 1 ? true : false,
                    }
                }
            ],
        };

        const classes = this.props;
        const { t } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                {/*<Dialog
                    open={this.state.CancelTVServiceDialogOpen}
                    onClose={this.handleCancelTVServiceDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{t('selfcare:dialog.cancel')} {this.state.CancelService && this.state.CancelService.Name}</DialogTitle>
                    <DialogContent>
                        {t('selfcare:dialog.selecttimecancellation', { 0: this.state.CancelService && this.state.CancelService.Name })}
                        {this.state.error ? <div style={{ color: 'red' }}>{this.state.error}</div> : <div />}
                        <FormControl component="fieldset" required>
                            <RadioGroup
                                aria-label={t('selfcare:label.when')}
                                name="when"
                                value={this.state.value}
                                onChange={this.handleChange}
                            >
                                <FormControlLabel value="direct" control={<Radio />} label={t('selfcare:label.direct')} />
                                <FormControlLabel value="endofperiod" control={<Radio />} label={t('selfcare:label.afterperiod')} />
                            </RadioGroup>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.dispatchState({ CancelTVService: this.state.password }); }} color="rose">
                            {t('selfcare:button.proceeduc')}
                        </Button>
                        <Button onClick={this.handleCancelTVServiceDialogClose}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>*/}
                <Dialog
                    open={this.state.EnterPasswordDialogOpen}
                    onClose={() => { this.setState({ EnterPasswordDialogOpen: false, buzy: false }); }}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <div style={{ display: 'flex' }}>
                            <Icon name="edit" size={36} color="#e91e63" />
                            <span style={{ marginLeft: '20px', fontWeight: '700' }}>{t('selfcare:dialog.codesetbylegalowner')}</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.PasswordText}<br />
                        <TextField
                            style={{ width: '100%' }}
                            id="password"
                            label={t('selfcare:label.code')}
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange('password')}
                            margin="normal"
                        />
                        {this.state.PasswordErrorText && <div style={{ width: '100%', padding: '5px', backgroundColor: '#e91e63', color: 'white', fontSize: '12px' }}>{this.state.PasswordErrorText}</div>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.dispatchState({ SetPassword: this.state.password }); }} color="rose">
                            {t('selfcare:button.proceeduc')}
                        </Button>
                        <Button onClick={() => { this.setState({ EnterPasswordDialogOpen: false, buzy: false }); }}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.EnterPassCodeDialogOpen}
                    onClose={() => { this.setState({ EnterPassCodeDialogOpen: false, buzy: false }); }}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <div style={{ display: 'flex' }}>
                            <Icon name="edit" size={36} color="#e91e63" />
                            <span style={{ marginLeft: '20px', fontWeight: '700' }}>Tast inn kode fra SMS</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {this.state.PassCodeText}<br />
                        <TextField
                            style={{ width: '100%' }}
                            id="passcode"
                            label={t('selfcare:label.code')}
                            type="phone"
                            value={this.state.passCode}
                            onChange={this.handleInputChange('passCode')}
                            margin="normal"
                        />
                        {this.state.PassCodeErrorText && <div style={{ width: '100%', padding: '5px', backgroundColor: '#e91e63', color: 'white', fontSize: '12px' }}>{this.state.PassCodeErrorText}</div>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.dispatchState({ SetPassCode: this.state.passCode }); }} color="rose">
                            {t('selfcare:button.send-order-uc')}
                        </Button>
                        <Button onClick={() => { this.setState({ EnterPassCodeDialogOpen: false, buzy: false }); }}>
                            {t('selfcare:button.cancel-uc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.ChangeTVServiceDialogOpen}
                    onClose={this.handleChangeTVServiceDialogClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">{t('selfcare:title.change-tv-package', { packageName: this.state.GroupName })}</DialogTitle>
                    <DialogContent>
                        {t('selfcare:dialog.wishtochangepackage', { 0: this.state.CurrentService ? this.state.CurrentService.Variant : null, 1: this.state.SelectedPackage ? this.state.SelectedPackage.Variant : null })}
                        <br /><br />
                        {this.state.SelectedPackage && this.state.SelectedPackage.IsDowngrade ? t('selfcare:dialog.changeeffectiveafterperiod') : null}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleConfirmChangeTVServiceDialogClose} color="rose">
                            {t('selfcare:button.confirmuc')}
                        </Button>
                        <Button onClick={this.handleChangeTVServiceDialogClose}>
                            {t('selfcare:button.canceluc')}
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.Type === 'Loading' &&
                    <GridContainer justify="center" alignItems="center" style={{ height: '100vh' }}>
                        <GridItem>
                            <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                        </GridItem>
                    </GridContainer>}
                {this.state.Type !== 'Loading' &&
                    <div>
                        {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', height: '50px', paddingLeft: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.nowadministratingnumber', { 0: this.state.AdministratedMsisdn }) }} /><br /><a style={{ color: 'white' }} href='/overview' onClick={(e) => { sessionStorage.stopAdmin = this.state.LoggedInMsisdn; this.navigateTo('/overview'); e.preventDefault(); }}>{t('selfcare:button.backtologgedinuser')}</a></div>}
                    {/*<Slide direction="down" in={this.state.show} mountOnEnter unmountOnExit>*/}
                            <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }} className='white-links'>
                                <GridContainer justify="center">
                                    <GridItem xs={12} sm={10} md={8} lg={6} xl={4}>
                                        <Icon name={this.state.Image} size={48} color="#FFFFFF" />
                                        <div style={{ fontSize: '24px' }}>
                                            {this.state.Title}
                                        </div>
                                        <div style={{ fontSize: '18px', fontWeight: 700 }}>
                                            {this.state.InitialFee &&
                                                <div>{t('selfcare:item.initialfee')}: {this.state.InitialFee}</div>}
                                            {this.state.MonthlyFee &&
                                                <div>{t('selfcare:item.permonth')}: {this.state.MonthlyFee}</div>}
                                        </div>
                                        {this.state.Description && <div style={{ paddingTop: '10px', fontSize: '14px', lineHeight: '16px' }} dangerouslySetInnerHTML={{ __html: this.state.Description }} />}
                                        {this.state.LongDescription && <Collapse accordion={true} style={{ fontSize: '14px' }}>
                                            <Panel header={t('selfcare:label.readmore')}>
                                                <span dangerouslySetInnerHTML={{ __html: this.state.LongDescription }} />
                                            </Panel>
                                        </Collapse>}
                                    </GridItem>
                                </GridContainer>
                            </div>
                    {/*</Slide>
                        <Slide direction="up" in={this.state.show} mountOnEnter unmountOnExit>*/}
                            <div>
                                {!this.state.CanChangeServices && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{t('selfcare:info.howtochangeservices')}</div>}
                                <div>
                                    {(this.state.Type === 'Service' || this.state.Type === 'Group') &&
                                    <div style={{ paddingLeft: '20px', paddingTop: '20px' }}>
                                            <GridContainer direction="row" justify="center" alignItems="center">
                                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4}>
                                                    <GridContainer justify="center" direction="column">
                                                        {this.state.SelectSimType &&
                                                            <React.Fragment>
                                                                <div><b></b></div>
                                                                <FormControl error={this.state.ErrorField === 'SelectedSimType'}>
                                                                    <FormGroup>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Radio
                                                                                        checked={this.state.SelectedSimType === 'Standard'}
                                                                                        onChange={() => { this.dispatchState({ SelectedSimType: 'Standard' }); }}
                                                                                        value='Standard'
                                                                                        disabled={this.state.DisableButtons || !this.state.CanChangeServices}
                                                                                    />
                                                                                }
                                                                                label={t('selfcare:label.physical-sim')}
                                                                                labelPlacement="end"
                                                                            />
                                                                            <div>
                                                                                <IconButton
                                                                                    aria-owns="Standard"
                                                                                    aria-haspopup="true"
                                                                                    aria-label={t('selfcare:label.help')}
                                                                                    onClick={(e) => { this.handleClick(e, "Standard"); }}
                                                                                >
                                                                                    <Icon name="information" size={24} color="#e91e63" />
                                                                                </IconButton>
                                                                                <Popover
                                                                                    id="Standard"
                                                                                    open={this.state.openedPopoverId === "Standard"}
                                                                                    anchorEl={anchorEl}
                                                                                    onClose={this.handleClose}
                                                                                    anchorOrigin={{
                                                                                        vertical: 'center',
                                                                                        horizontal: 'left',
                                                                                    }}
                                                                                    transformOrigin={{
                                                                                        vertical: 'center',
                                                                                        horizontal: 'right',
                                                                                    }}
                                                                                >
                                                                                    <div style={{ padding: '10px', maxWidth: '400px', fontSize: '12px' }}>
                                                                                        {t('selfcare:info.after-order-sim-is-sent')}
                                                                                    </div>
                                                                                </Popover>
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Radio
                                                                                        checked={this.state.SelectedSimType === 'eSim'}
                                                                                        onChange={() => { this.dispatchState({ SelectedSimType: 'eSim' }); }}
                                                                                        value='eSim'
                                                                                        disabled={this.state.DisableButtons || !this.state.CanChangeServices}
                                                                                    />
                                                                                }
                                                                                label={t('selfcare:label.esim')}
                                                                                labelPlacement="end"
                                                                            />
                                                                            <div>
                                                                                <IconButton
                                                                                    aria-owns="eSim"
                                                                                    aria-haspopup="true"
                                                                                    aria-label={t('selfcare:label.help')}
                                                                                    onClick={(e) => { this.handleClick(e, "eSim"); }}
                                                                                >
                                                                                    <Icon name="information" size={24} color="#e91e63" />
                                                                                </IconButton>
                                                                                <Popover
                                                                                    id="eSim"
                                                                                    open={this.state.openedPopoverId === "eSim"}
                                                                                    anchorEl={anchorEl}
                                                                                    onClose={this.handleClose}
                                                                                    anchorOrigin={{
                                                                                        vertical: 'center',
                                                                                        horizontal: 'left',
                                                                                    }}
                                                                                    transformOrigin={{
                                                                                        vertical: 'center',
                                                                                        horizontal: 'right',
                                                                                    }}
                                                                                >
                                                                                    <div style={{ padding: '10px', maxWidth: '400px', fontSize: '12px' }}>
                                                                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.esim', { 0: this.state.SimEmail }) }} />
                                                                                    </div>
                                                                                </Popover>
                                                                            </div>
                                                                        </div>
                                                                    </FormGroup>
                                                                    <FormHelperText>{this.state.ErrorField === 'SelectedSimType' && this.state.ErrorText}</FormHelperText>
                                                                </FormControl>
                                                            </React.Fragment>
                                                        }
                                                        {this.state.SendSimCard && this.state.SelectedSimType === 'Standard' &&
                                                            <GridItem>
                                                                <p><b>{t('selfcare:item.simsentto')}:</b></p>
                                                                <span dangerouslySetInnerHTML={{ __html: this.state.SimAddress }} />
                                                                <a href="/change-address" style={{ marginLeft: '30px' }}><BorderColorIcon style={{ color: '#da2f63', marginBottom: '-6px', width: '20px', marginRight: '6px' }} />{t('selfcare:phrase.change')}</a>
                                                            </GridItem>}
                                                        {this.state.SendSimCard && this.state.SelectedSimType === 'eSim' &&
                                                            <GridItem>
                                                                <p><b>{t('selfcare:info.qr-esim-sent')}:</b></p>
                                                                <span dangerouslySetInnerHTML={{ __html: this.state.SimEmail }} />
                                                            </GridItem>}
                                                        <GridItem>
                                                            {this.state.GroupHeader && <b>
                                                                {this.state.GroupHeader}
                                                            </b>}
                                                            <FormGroup>
                                                                {this.state.GroupType === 'Single' && this.state.ServiceOptions && this.state.ServiceOptions.map((option) => {
                                                                    return (
                                                                        <FormControlLabel key={option.ServiceNo}
                                                                            control={
                                                                                <Radio
                                                                                    checked={option.Checked}
                                                                                    onChange={() => { this.dispatchState({ SelectionChanged: option.ServiceNo }) }}
                                                                                    value={option.ServiceNo}
                                                                                    disabled={this.state.DisableButtons || !this.state.CanChangeServices}
                                                                                />
                                                                            }
                                                                            label={option.Name}
                                                                            labelPlacement="end"
                                                                        />
                                                                    );
                                                                })}
                                                                {this.state.GroupType === 'Multi' && this.state.ServiceOptions && this.state.ServiceOptions.map((option) => {
                                                                    return (
                                                                        <div style={{ display: 'flex', alignItems: 'center' }} key={option.ServiceNo}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={option.Checked}
                                                                                        onChange={() => { this.dispatchState({ SelectionChanged: option.ServiceNo }) }}
                                                                                        value={option.ServiceNo}
                                                                                        disabled={this.state.DisableButtons || !this.state.CanChangeServices}
                                                                                    />
                                                                                }
                                                                                label={<div style={{ display: 'flex', alignItems: 'center', marginRight: '-15px' }}>
                                                                                    {option.Name}
                                                                                </div>}
                                                                                labelPlacement="end"
                                                                            />
                                                                            {option.HelpText &&
                                                                                <div>
                                                                                    <IconButton
                                                                                        aria-owns={option.ServiceNo}
                                                                                        aria-haspopup="true"
                                                                                        aria-label={t('selfcare:label.help')}
                                                                                        onClick={(e) => { this.handleClick(e, option.ServiceNo); }}
                                                                                    >
                                                                                        <Icon name="information" size={24} color="#e91e63" />
                                                                                    </IconButton>
                                                                                    <Popover
                                                                                        id={option.ServiceNo}
                                                                                        open={this.state.openedPopoverId === option.ServiceNo}
                                                                                        anchorEl={anchorEl}
                                                                                        onClose={this.handleClose}
                                                                                        anchorOrigin={{
                                                                                            vertical: 'center',
                                                                                            horizontal: 'left',
                                                                                        }}
                                                                                        transformOrigin={{
                                                                                            vertical: 'center',
                                                                                            horizontal: 'right',
                                                                                        }}
                                                                                    >
                                                                                        <div style={{ padding: '10px', maxWidth: '400px', fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: option.HelpText }} />
                                                                                    </Popover>
                                                                                </div>}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </FormGroup>
                                                        </GridItem>
                                                        {this.state.OrderOpen && <GridItem>
                                                            <div style={{ width: '100%' }}>
                                                                {t('selfcare:info.orderprocessed')}
                                                            </div>
                                                        </GridItem>}
                                                        {this.state.IsCostControl && <GridItem>
                                                    <div style={{ width: '100%' }}>
                                                        <div><b>Tjänsten Kostnadskontroll är {this.state.TurnOn ? "inte aktiverad" : "aktiverad"}</b></div>
                                                        <div style={{ marginTop: '10px' }}>
                                                            {this.state.TurnOn ? "När tjänsten Kostnadskontroll aktiveras betyder det att inga rörliga kostnader kan belasta ditt betalkort." : "När tjänsten Kostnadskontroll stängs av betyder det att rörliga kostnader såsom utlandssamtal och andra betaltjänster kommer att belasta ditt betalkort vid nästa dragning från oss."}<br/>{this.state.PerformCreditCheck ? "Om du väljer att stänga av tjänsten kommer en kreditkontroll att utföras." : ""}
                                                        </div>
                                                        </div>
                                                        </GridItem>
                                                        }
                                                        <GridItem>
                                                            <GridContainer direction="row">
                                                                <GridItem>
                                                                    <div style={{ paddingTop: '20px' }}>
                                                                        <Button size="sm" onClick={() => { this.dispatchState({ PerformChange: true }); this.setState({ buzy: true }); }} disabled={!this.state.CanSave || this.state.DisableButtons || this.state.buzy || !this.state.CanChangeServices} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose"> {this.state.ButtonText} </Button>
                                                                        {this.state.CanCancelService && <Button onClick={() => { this.dispatchState({ PerformChange: false }); this.setState({ buzy: true }); }} size="sm" variant="contained" disabled={this.state.DisableButtons || this.state.buzy || !this.state.CanChangeServices} style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:info.cancelservice')}</Button>}
                                                                        <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                                                    </div>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </GridItem>
                                                        {this.state.buzy && <GridItem>
                                                            <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                        </GridItem>}
                                                    </GridContainer>
                                                </GridItem>
                                            </GridContainer>
                                        </div>}
                                {this.state.Type === 'TV' &&
                                    <div style={{ paddingLeft: '20px', paddingTop: '20px' }}>
                                        <form>
                                            <GridContainer direction="row" justify="center" alignItems="center">
                                                <GridItem xs={10} >
                                                    <div>
                                                        <Slider {...settings}>
                                                            {this.state.Options ? this.state.Options.map((pack) => {
                                                                return (
                                                                    <Card raised key={pack.ServiceNo}>
                                                                        <CardBody>
                                                                            <GridContainer justify="center">
                                                                                <GridItem>
                                                                                    <div style={{ fontSize: '22px', width: '240px', height: '70px', textAlign: 'center' }} className={classes.cardCategory}>{pack.Variant}</div>
                                                                                </GridItem>
                                                                            </GridContainer>
                                                                            <div style={{ height: '180px', textAlign: 'left' }} className={classes.cardDescription} dangerouslySetInnerHTML={{ __html: pack.Description }} />
                                                                            <GridContainer direction="column" justify="center" alignItems="center">
                                                                                <GridItem>
                                                                                    <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
                                                                                        {pack.Fee}
                                                                                    </h3>
                                                                                </GridItem>
                                                                                <GridItem>
                                                                                    {pack.Ordered ? <Button size="sm" round disabled>{t('selfcare:button.ordered')}</Button> : !pack.Current ? <Button size="sm" round color="rose" disabled={this.state.DisableButtons || this.state.buzy || !this.state.CanChangeServices} onClick={() => this.handleSelectPackage(pack)}>{pack.CanChangeTo ? t('selfcare:button.change-to') : t('selfcare:button.order')}</Button> : <Button size="sm" round disabled>{t('selfcare:button.current')}</Button>}
                                                                                    {pack.CanCancel && <Button onClick={() => { this.cancelTVService(pack); }} style={{ marginLeft: '10px' }} size="sm" color="rose" round >{t('selfcare:button.cancelorder')}</Button>}
                                                                                </GridItem>
                                                                            </GridContainer>
                                                                        </CardBody>
                                                                    </Card>
                                                                )
                                                            }) : null}
                                                        </Slider>
                                                        <GridContainer justify="center">
                                                            <GridItem>
                                                                <div style={{ paddingTop: '40px' }}>
                                                                    {this.state.buzy && <CircularProgress size={48} style={{
                                                                        color: '#C2185B', position: 'absolute',
                                                                        top: '20%',
                                                                        left: '50%',
                                                                        marginTop: -12,
                                                                        marginLeft: -12,
                                                                    }} />}
                                                                    {this.state.OrderOpen && <div>{t('selfcare:info.orderprocessed')}</div>}
                                                                    <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                                                </div>
                                                            </GridItem>
                                                        </GridContainer>

                                                    </div>
                                                </GridItem>
                                            </GridContainer>
                                        </form>
                                    </div>}
                                {this.state.Type === "Activate" &&
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                    {this.state.ViaplayPreOfferText ?
                                        <div style={{ padding: '20px'}}>{this.state.ViaplayPreOfferText}</div>
                                    : <React.Fragment>
                                            {this.state.ShowViaplayOffer &&
                                                <div style={{ maxWidth: '360px', margin: '20px 10px', borderRadius: '10px', border: '1px solid #555', textAlign: 'center', backgroundColor: '#FFF', boxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', WebkitBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', MozBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)' }}>
                                                    <div style={{ padding: '10px', textAlign: 'center' }}>
                                                        <p style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: this.state.ViaplayText }} /></p>

                                                        <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
                                                            <Button style={{ borderRadius: '16px' }} id='register-viaplay' size="sm" color="rose" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                this.dispatchState({ AcceptViaplayOffer: true }); this.setState({ ViaplayBuzy: true });
                                                            }}
                                                            >
                                                                Aktivera Viaplay
                                                                        </Button>
                                                            <Button style={{ borderRadius: '16px' }} variant="outlined" size="sm" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                this.dispatchState({ AcceptViaplayOffer: false }); this.setState({ ViaplayBuzy: true });
                                                            }}
                                                            >
                                                                Nej tack
                                                                            </Button>
                                                        </div>
                                                        {this.state.ViaplayBuzy &&
                                                            <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                            </div>}
                                                    </div>
                                                </div>}
                                            {this.state.ShowActivateViaplay &&
                                                <div style={{ maxWidth: '360px', margin: '20px 10px', borderRadius: '10px', border: '1px solid #555', textAlign: 'center', backgroundColor: '#FFF', boxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', WebkitBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)', MozBoxShadow: '4px 9px 22px 0 rgba(0, 0, 0, 0.13)' }}>
                                                    <div style={{ padding: '10px', textAlign: 'center' }}>
                                                        <p style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: this.state.ViaplayText }} /></p>
                                                        <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                                            <Button style={{ marginRight: '5px', borderRadius: '16px' }} id='register-viaplay' size="sm" color="rose" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                this.dispatchState({ ActivateViaplay: true }); this.setState({ ViaplayBuzy: true });
                                                            }}
                                                            >
                                                                {t('selfcare:button.activate-viaplay')}
                                                            </Button>
                                                            <Button style={{ borderRadius: '16px' }} variant="outlined" size="sm" disabled={this.state.ViaplayBuzy} onClick={() => {
                                                                this.dispatchState({ ActivateViaplay: false }); this.setState({ ViaplayBuzy: true });
                                                            }}
                                                            >
                                                                {t('selfcare:button.cancelorder')}l
                                                                            </Button>
                                                        </div>
                                                        {this.state.ViaplayBuzy &&
                                                            <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                                                <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                                            </div>}
                                                    </div>
                                                </div>}
                                        </React.Fragment>}
                                    </div>
                                }
                                {this.state.Type === "Activate" &&
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                        <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                    </div>}
                                </div>
                            </div>
                    {/*</Slide>*/}
                    </div>}
            </div>
        );
    }
}
ChangeService.propTypes = {
};

export default compose(
    withStyles(pricingPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, ChangeService));

